import { AppProviders } from './providers';
import { TripRouterProvider } from './router-trip';
import TripListPage from '@/pages/trip/TripListPage';
import { ErrorBoundary } from '@/components/error/ErrorBoundary';
import { ToastContainer } from '@/components/ui/ToastContainer';

interface TripAppProps {
  slug: string | null;
}

export default function TripApp({ slug }: TripAppProps) {
  if (!slug) {
    return (
      <AppProviders>
        <ErrorBoundary label="Trip-App">
          <TripListPage />
        </ErrorBoundary>
        <ToastContainer />
      </AppProviders>
    );
  }

  return (
    <AppProviders>
      <ErrorBoundary label="Trip-App">
        <TripRouterProvider slug={slug} />
      </ErrorBoundary>
      <ToastContainer />
    </AppProviders>
  );
}
